import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { register as registerSwiperElements } from 'swiper/element/bundle';
import zh from '@angular/common/locales/zh';
import es from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';

registerLocaleData(zh);
registerLocaleData(es);

if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.sentryEnvironment,
    release: environment.sentryRelease || undefined,
    sendDefaultPii: false,
    dataCollection: {
      userInfo: false
    },
    enableLogs: false
  });
}

registerSwiperElements();
bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
